// src/redux/slices/loanReportSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL;

// // Fetch all loans
// export const fetchLoanReports = createAsyncThunk(
//   'loanReport/fetchLoanReports',
//   async (_, { rejectWithValue }) => {
//     try {
//       const authToken = localStorage.getItem('authToken');
//       if (!authToken) return rejectWithValue('Authorization token is missing.');

//       const response = await axios.get(`${BASE_URL}/get-all-loan`, {
//         headers: { Authorization: `Bearer ${authToken}` },
//       });

//       return response.data.data;
//     } catch (error) {
//       const message = error.response?.data?.message || error.message || 'Unknown error';
//       return rejectWithValue(message);
//     }
//   }
// );

// Fetch all loans with optional superAdminId filter
export const fetchLoanReports = createAsyncThunk(
  'loanReport/fetchLoanReports',
  async (superAdminId, { rejectWithValue }) => {
    try {
      const authToken = localStorage.getItem('authToken');
      if (!authToken) return rejectWithValue('Authorization token is missing.');


      let   superAdminId = localStorage.getItem("adminuserId");

      let url = `${BASE_URL}/get-all-loan`;
      
      // Append query param if superAdminId is provided
      if (superAdminId) {
        url += `?superAdminId=${superAdminId}`;
      }

      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${authToken}` },
      });

      return response.data.data;
    } catch (error) {
      const message = error.response?.data?.message || error.message || 'Unknown error';
      return rejectWithValue(message);
    }
  }
);


// Delete a loan by ID
export const deleteLoan = createAsyncThunk(
  'loanReport/deleteLoan',
  async (loanId, { rejectWithValue }) => {
    try {
      const authToken = localStorage.getItem('authToken');
      if (!authToken) return rejectWithValue('Authorization token is missing.');

      await axios.delete(`${BASE_URL}/delete-loan/${loanId}`, {
        headers: { Authorization: `Bearer ${authToken}` },
      });

      return loanId; // Return deleted ID to remove from state
    } catch (error) {
      const message = error.response?.data?.message || error.message || 'Delete failed';
      return rejectWithValue(message);
    }
  }
);

const loanReportSlice = createSlice({
  name: 'loanReport',
  initialState: {
    loans: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch Loans
      .addCase(fetchLoanReports.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLoanReports.fulfilled, (state, action) => {
        state.loading = false;
        state.loans = action.payload;
      })
      .addCase(fetchLoanReports.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Delete Loan
      .addCase(deleteLoan.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteLoan.fulfilled, (state, action) => {
        state.loading = false;
        state.loans = state.loans.filter((loan) => loan.id !== action.payload);
      })
      .addCase(deleteLoan.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default loanReportSlice.reducer;
